import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { useAuthenticatedRequestCreator } from "./useRequests";

export enum ConfirmationType {
    Unknown = 0,
    Email = 1,
    MFA = 2
}

export interface ConfirmationResult {
    method: ConfirmationType;
    emailGenerated: boolean;
}

const useAccountConfirmation = () => {
    const [cache, setCache] = useState<ConfirmationResult>();

    const post = useAuthenticatedRequestCreator<ConfirmationResult, void>(() => ({
        method: "POST",
        url: "/account/request-confirmation"
    }));

    const requestGate = async () => {
        if (cache !== undefined) {
            return cache;
        }

        var result = await post();
        setCache(result);

        return result;
    };

    const { mutateAsync: requestConfirmation, isLoading } = useMutation(requestGate);

    return {
        requestConfirmation,
        isLoading
    };
};

export default useAccountConfirmation;